/**
 * PLATFORM_REDIRECT_ROUTES — the Admin Panel's routes as REAL route elements,
 * consumed by BOTH App.tsx and the route test (single source, same pattern
 * as the S4 settings array).
 *
 * /admin renders AdminPage behind PlatformGate (O47): elevated users get the
 * page (it reads ?tab= itself), everyone else the gate's honest empty state.
 * The retired /platform scope and everything under it (old bookmarks such as
 * /platform/agency-integrations?tab=users) redirect to /admin, gated the same
 * way, keeping the query string. The old agency-integrations page landed on
 * AdminPage's Integrations tab, so a link to it that names no tab still does. The telemetry routes (/admin/research-coverage,
 * /admin/llm-benchmarks, …) are NOT here — they stay routed in App.tsx.
 */

import { Navigate, Route, useParams, useSearchParams } from 'react-router-dom';
import AdminPage from '@/pages/AdminPage';
import { COPY } from '@/lib/copyTokens';
import { PlatformGate } from './PlatformGate';

function RetiredPlatformRedirect() {
  const [searchParams] = useSearchParams();
  const rest = useParams()['*'] ?? '';
  const next = new URLSearchParams(searchParams);
  if (rest.split('/')[0] === 'agency-integrations' && !next.has('tab')) next.set('tab', 'integrations');
  const qs = next.toString();
  return <Navigate to={{ pathname: COPY.adminPanel.path, search: qs ? `?${qs}` : '' }} replace />;
}

export const PLATFORM_REDIRECT_ROUTES = [
  <Route
    key="admin"
    path="admin"
    element={
      <PlatformGate>
        <AdminPage />
      </PlatformGate>
    }
  />,
  <Route
    key="platform"
    path="platform/*"
    element={
      <PlatformGate>
        <RetiredPlatformRedirect />
      </PlatformGate>
    }
  />,
];
